import React from 'react';
import Button from './Button';

function Input(props) {

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && props.value.trim() !== '') {
            props.onSearch();
        }
    };

    return (
        <div className='input_wrapper'>
            <div className='search_icon_wrapper'>
                <span className="fa-solid fa-magnifying-glass search_icon"></span>
            </div>
            <input
                type={props.type}
                className={props.class}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.onChange}
                onKeyDown={handleKeyDown}
            />
            <Button
                text="Search"
                class="search_button"
                onClick={props.onSearch}
            />
        </div>
    );
}

export default Input;